<template>
  <div class="app-root">
    <Authenticator>
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template v-slot="{ signOut }">
        <AuditionPrep />
      </template>
    </Authenticator>
  </div>
</template>

<script>
import { Authenticator } from '@aws-amplify/ui-vue'
import '@aws-amplify/ui-vue/styles.css'
import AuditionPrep from './components/AuditionPrep.vue'
export default {
  name: 'App',
  components: {
    Authenticator,
    AuditionPrep
  }
}
</script>

<style>
:root {
  --bg: #0d0d0f;
  --surface: #16161a;
  --border: rgba(255, 255, 255, 0.08);
  --border-active: rgba(255, 255, 255, 0.22);
  --text: #f0ede8;
  --muted: #888;
  --gold: #c9a84c;
  --gold-dim: rgba(201, 168, 76, 0.12);
  --red: #e05a5a;
  --green: #5ab88a;
  --blue: #5a9be0;
  --blue-dim: rgba(90, 155, 224, 0.12);
  --radius: 10px;
}

body {
  font-family: 'DM Sans', sans-serif;
  background: var(--bg);
  color: var(--text);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.sign-out-bar {
  text-align: center;
  padding: 1.5rem;
}

.sign-out-btn {
  padding: 0.4rem 1.2rem;
  font-size: 0.8rem;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  color: #888;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: all 0.15s;
}

.redirect-msg {
  text-align: center;
  padding: 3rem;
  color: #888;
  font-size: 0.9rem;
}
</style>
